var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutHistoryItem',{attrs:{"data-qa":_vm.dataQa,"item":_vm.item,"spr":_vm.spr},scopedSlots:_vm._u([{key:"parameters",fn:function(){return [_c('div')]},proxy:true}])},[_c('span',{attrs:{"slot":"eventType"},slot:"eventType"},[_vm._v(" "+_vm._s(_vm.customTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }